import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PricingPortalAPI } from "../../../apis/pricing-api";
import { selectSessionConfig } from "../../../store/store-selector";
import { selectUser } from "../../../store/store-selector";
import { useSelector } from "react-redux";
import ButtonGroup from "../../../components-old/elements/ButtonGroup/ButtonGroup";

const SendEmailPopup = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [isConfirming, setIsConfirming] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [approvers, setApprovers] = useState([]);
    const [isSendEnabled, setIsSendEnabled] = useState(false);

    const settingsConfig = useSelector(selectSessionConfig);
    const user = useSelector(selectUser);

    // Styles for the popup
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2
        },
        popup: {
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "400px",
            textAlign: "center",
        },
        select: {
            marginTop: "5px",
            marginBottom: "10px",
            padding: "8px",
            width: "100%",
        },
        buttonContainer: {
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-around",
        },
        cancelButton: {
            padding: "10px 20px",
            backgroundColor: "#ccc",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
        },
        sendButton: {
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            border: "none",
            borderRadius: "5px",
            color: "white",
            cursor: "pointer",
        },
    };

    // Handle dropdown selection change
    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        setIsSendEnabled(value !== "");
    };

    // Handle send email action
    const handleSendEmail = async () => {
        if (isConfirming) return; // Prevent double-click

        setIsConfirming(true);

        try {
            await onConfirm(selectedOption);
            setSelectedOption("");
            setIsSendEnabled(false);
            onClose();
        } catch (error) {
            alert(error);
        } finally {
            setIsConfirming(false);
        }
    };

    const buttonConfigs = [{
        buttonText: t("popup.cancel"),
        onClick: onClose,
        buttonType: "outlined",
        buttonColor: "#A62B23",
        textColor: "#A62B23",
    }, {
        buttonText: t("sendEmail.header"),
        onClick: handleSendEmail,
        buttonType: "filled",
        buttonColor: "#A62B23",
        textColor: "#fff",
        disabled: !isSendEnabled
    }]
    // Fetch approvers list from the API
    const fetchApproversList = async () => {
        try {
            const _approverList = await PricingPortalAPI.getFilterList(
                settingsConfig.businessCode,
                settingsConfig.countryCode,
                "getAllUserWithRolesList",
                "userroles",
                "&role=PCA"
            );

            return _approverList;
        } catch (error) {
            console.error("Error fetching approvers:", error);
            return [];
        }
    };


    useEffect(() => {
        const getApprovers = async () => {
            const approversList = await fetchApproversList();
            const filteredApprovers = approversList.filter(approver => approver.UserEmail !== user.userRecord.email);

            setApprovers(filteredApprovers);
        };

        getApprovers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.popup}>
                <p><b>{t("sendEmail.header")}</b></p>
                <p style={{ textAlign: "left" }}>{t("sendEmail.selectApprover")}</p>

                <div>
                    <select
                        id="select-dropdown"
                        value={selectedOption}
                        onChange={handleSelectChange}
                        style={styles.select}
                    >
                        <option value="">{t("sendEmail.selectApprover")}</option>
                        {approvers.length > 0 ? (
                            approvers.map((approver, index) => (
                                <option key={index} value={approver.UserEmail}>
                                    {approver.UserEmail}
                                </option>
                            ))
                        ) : (
                            <option disabled>{t("popup.no_approvers")}</option>
                        )}
                    </select>
                </div>
                <ButtonGroup buttons={buttonConfigs} />
            </div>
        </div>
    );
};

export default SendEmailPopup;
